import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({ name: 'dateFormat' })
export class MomentPipe implements PipeTransform {
    transform(value: any | moment.Moment, dateFormat: string): any {
        return moment.utc(value).local().format(dateFormat);
    }
}
